import api from "../../utilities/Interceptor";
import { decrypt } from "../../utilities/Encriptacion";

const url = process.env.REACT_APP_API_KEY
interface Detail {
    CHOFER: string
    UNIT: string
    OP_IMG: string
    UNIT_IMG: string
}


export const getRoutes = (setRoutes: any, id: number, chose: boolean) => {
    const type = chose ? 'E' : 'S';
    api.get<{ ID: number, NOMBRE: string }>(`${url}/maps/routes/${id}?type=${type}`).then((res) => {
            setRoutes(res.data)
        }
    ).catch((error) => {
        console.log("error", error);
    })
}

export const getStroke = (setStroke: any, id_ruta: number, id_trazo: number | null) => {
    api.get(`${url}/maps/stroke?id_ruta=${id_ruta}&id_trazo=${id_trazo}`).then((res) => {
        const data = res.data;
            setStroke([data]);
        }

    ).catch((error) => {
        console.log("error", error);
    })

}

export const getAllStrokes = (setStrokes: any, setUnitPosition: any, chose: boolean) => {
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION;
    const dataClient = sessionStorage.getItem('dataClient');
    const id = decrypt(dataClient, CLAVE);
    const type = chose ? 'E' : 'S';

    api.get(`${url}/maps/getAllStrokes/${JSON.parse(id).id}?type=${type}`).then((res) => {
        const processedStrokes = res.data;
        setStrokes(processedStrokes);
        setUnitPosition(null);
    })
        .catch(error => {
            console.error("Error fetching all routes:", error);
        });
};


export const getUnitPosition = async (id: number | null, id_bitacora: number | null, setUnitPosition: any, setGetUnit: any) => {
    if (!id) {
        console.error("Invalid ID provided");
        setUnitPosition(null);
        setGetUnit(null);
        return null;
    }

    try {
        const response = await api.get(`${url}/maps/unit?id=${id}&id_bitacora=${id_bitacora}`);
        if(response.data) {
            const data = {
                position : response.data.position,
                unit: `U-${id}`,
                id
            }

            setUnitPosition(data);
        } else {
            setUnitPosition(null);
            setGetUnit(false);
        }

    } catch (error) {
        console.error("Error fetching unit position:", error);
    }
};

export const getDetail = (id: number, setDetail: any) => {
    api.get<Detail>(`${url}/maps/detail/${id}`).then((res) => {
            setDetail(res.data)
        }
    ).catch((error) => {
        console.log("error", error);
    })
}
